import { render } from "./MetadataVariableFlags.vue?vue&type=template&id=1acea0fe"
import script from "./MetadataVariableFlags.vue?vue&type=script&lang=js"
export * from "./MetadataVariableFlags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__